import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Menu } from 'src/app/models/generic/Menu';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { MatSidenav } from '@angular/material/sidenav';
import { ProductosService } from 'src/app/services/productos.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { ListaComponentes, OpcionesComponentes } from 'src/app/models/modules/OpcionesComponentes';
import { SeleccionAliadoCanalMenu } from 'src/app/models/generic/SeleccionAliadoCanalMenu';
import { SeleccionAliadoCanalComponent } from '../seleccionaliadocanal/seleccionaliadocanal.component';
import { ComponenteprincipalComponent } from '../componenteprincipal/componenteprincipal.component';
import { ExpedientesService } from 'src/app/services/expedientes.service';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { TemaVerificarService } from '../../services/temaverificar.service';
import { Theme } from 'src/app/theme/theme';

@Component({
  selector: 'globalnavbar',
  templateUrl: './globalnavbar.component.html',
  styleUrls: ['./globalnavbar.component.scss']
})
export class GlobalnavbarComponent implements OnInit{

  showFiller: boolean = false;
  ComponenteActivo: any;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appseleccionaliadocanal', {static: false}) _appseleccionaliadocanal: SeleccionAliadoCanalComponent;
  @ViewChild('componenteprincipal', {static: false}) _appcomponenteprincipal: ComponenteprincipalComponent;
  cerrarSesionUsuario: boolean = true;
  @ViewChild('sidenav', {static: true}) _sidenav: MatSidenav;
  mostrarCargandoExpediente: boolean = false;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService,
    public expedientesService: ExpedientesService,
    public temaVerificarService: TemaVerificarService) {}

  ngOnInit() {
    this.navegarPanelPrincipal();

    this.menuService.NotificarCambiarComponenteActivo.subscribe((configuracion: string) => {
      this.CambiarCambiarComponenteNavbar(configuracion);
      this.cd.detectChanges();
    });
  }

  isMenuOpen = false;
  contentMargin = 240;
  fixed: true;

  onToolbarMenuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  ngAfterViewInit() {
    this.tamanoAppService.VerificarAnchoPantallaActual();
  }

  @HostListener("window:resize", [])
  private onResize() {
    this.tamanoAppService.VerificarAnchoPantallaActual();
  }

  CambiarCambiarComponenteNavbar(codigoComponente: string) {
    // console.log('CambiarCambiarComponenteActivo', codigoComponente);
    this.menuService.IconoAdicionarServicio = 'add';
    let cambiarComponente: boolean = false;
    // console.log('CambiarCambiarComponenteActivo-Actual', this.ComponenteActivo);

    let listaDashboard: ListaComponentes[] = OpcionesComponentes.LISTA_COMPONENTES();
    for (let index = 0; index < listaDashboard.length; index++) {
      if (codigoComponente === listaDashboard[index].nombre) {
        this.ComponenteActivo = listaDashboard[index].componente;
        cambiarComponente = true;
      }
    }

    if (cambiarComponente) {
      if (this.utilitariosService.VerificarContieneDatos(this._appcomponenteprincipal)) {
        this._appcomponenteprincipal.VerificarComponenteDinamico(this.ComponenteActivo);
      }
    }

    // console.log('CambiarCambiarComponenteActivo-Nuevo', this.ComponenteActivo);

    if (codigoComponente === 'RegistrarAfiliadoComponent') {
      this.menuService.IconoAdicionarServicio = 'check';
    }
  }

  AccionMenu(itemMenuHijo: Menu) {
    // console.log('AccionMenu', itemMenuHijo);
    if (itemMenuHijo.componente === 'cerrarsesion') {
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      if (this.utilitariosService.VerificarContieneDatosTexto(itemMenuHijo.componente)) {
        this.VerificarAliadoCanalRequerido(itemMenuHijo);
      }
    }
  }

  VerificarAliadoCanalRequerido(itemMenuHijo: Menu) {
    if (itemMenuHijo.requiereAliado && this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.AplicacionSeleccionado) === false) {
      this._appseleccionaliadocanal.MostrarMensajeConfirmacion(itemMenuHijo);
    } else if (itemMenuHijo.requiereCanal && this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.CanalSeleccionado) === false) {
      this._appseleccionaliadocanal.MostrarMensajeConfirmacion(itemMenuHijo);
    } else {
      this.menuService.CambiarComponenteActivo(itemMenuHijo.componente);
    }
  }

  navegarPanelPrincipal() {
    this.CambiarCambiarComponenteNavbar(this.autenticacionService.Componente);
  }

  CerrarSesion() {
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }

  AccionBoton() {
    if (this.menuService.IconoAdicionarServicio === 'add') {
      this.menuService.CambiarComponenteActivo('RegistrarAfiliadoComponent');
    } else {
      this.menuService.EjecutarNotificarAccionBotonPrincipal();
    }
  }

  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.autenticacionService.LimpiarUsuario();
      this.router.navigate(['login']);
    } else {
      this.cerrarSesionUsuario = true;
    }
  }

  CambioAliadoCanal(cambio: boolean) {
    if (cambio) {
      this.CambiarCambiarComponenteNavbar('CargandoComponent');
    }
  }

  SeleccionoAliadoCanal(registroUsuario: SeleccionAliadoCanalMenu) {
    // console.log('SeleccionoAliadoCanal', registroUsuario);
    if (registroUsuario.confirmoUsuario) {
      this.isMenuOpen = false;
      if (this.utilitariosService.VerificarContieneDatos(registroUsuario.menu)) {
        this.menuService.CambiarComponenteActivo(registroUsuario.menu.componente);
      } else {
        this.CambiarCambiarComponenteNavbar(this.autenticacionService.Componente);
      }
    }
  }

  CambiarCanal() {
    let requiereCanal: boolean = false;
    if (this.autenticacionService.CanalSeleccionado > 0) {
      requiereCanal = true;
    }
    this._appseleccionaliadocanal.MostrarSeleccionAliadoCanal(requiereCanal);
  }

  VerificarSidenav(sidenav) {
    if (this.utilitariosService.VerificarContieneDatos(sidenav)) {
      return sidenav.opened;
    }
    return false;
  }

  ObtenerNombreUsuario(): string {
    let nombreUsuarioRetorno: string = '';
    if (this.utilitariosService.VerificarContieneDatos(this.autenticacionService.UsuarioActivo)) {
      nombreUsuarioRetorno = this.autenticacionService.UsuarioActivo.nombre;
    }
    return nombreUsuarioRetorno;
  }

  abrirModalFirmaElectronica() {
    this.menuService.CambiarComponenteActivo('FirmaElectronicaGenerarComponent');
  }

  abrirModalOperacionesReembolso() {
    this.menuService.CambiarComponenteActivo('OperacionesReembolsoUbicacionComponent');
  }

  VerificarMostrarFirmaElectronica(): boolean {
    return this.menuService.TienePermisoEscrituraEnMenu('FirmaElectronicaComponent');
  }

  VerificarMostrarOperacionesReembolso(): boolean {
    return this.menuService.TienePermisoEscrituraEnMenu('OperacionesReembolsoComponent');
  }
  VerificarMostrarExpedientes(): boolean {
    return this.menuService.TieneSeleccionadoComponente('ExpedientesComponent')
      || this.menuService.TieneSeleccionadoComponente('ExpedientesDetalleComponent');
  }
  ejecutarSincronizacionExpediente() {
    this.mostrarCargandoExpediente = true;
    let parametrosConsulta: FormGroup = this.fb.group({
      codigoExpediente: [''],
      idAplicacion: [0]
    });
    
    parametrosConsulta.get('codigoExpediente').setValue('');
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);

    this.expedientesService.GenerarSincronizacion(parametrosConsulta.value)
              .subscribe((resp: RespuestaGenerica[]) =>{
                this.menuService.NotificarRecargarExpedientes.emit('');
                this.mostrarCargandoExpediente = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.cd.detectChanges();
                this.mostrarCargandoExpediente = false;
              },
              () => this.cd.detectChanges());    
  }
  TemaActivoSura(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.sura;
  }
  TemaActivoAquaShield(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.aquashield;
  }
  TemaActivoCobelen(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.cobelen;
  }
  TemaActivoGlobal(): boolean {
    return this.temaVerificarService.VerificarTemaActivo() === Theme.global;
  }
}
